import { useRuntimeConfig } from '#app';

// Cache the proxy host at module level — it's a deployment-time constant (same for all requests).
// This avoids calling useRuntimeConfig() on every image URL, which crashes during SSR when
// called inside reactive callbacks (Vue's proxy .forEach() loses Nuxt's async context).
let _cachedProxyHost: string | null = null;

function getProxyHost(): string {
    if (_cachedProxyHost) return _cachedProxyHost;
    try {
        const runtimeConfig = useRuntimeConfig();
        const siteName: string = runtimeConfig.public.imageProxyHost || 'dev.tripening.com';
        const isDev: boolean = runtimeConfig.public.envName === 'dev';
        const imgproxyServer: string = isDev ? 'imgproxy-' : 'imgproxy.';
        _cachedProxyHost = siteName ? 'https://' + imgproxyServer + siteName : 'https://imgproxy-dev.tripening.com';
    } catch {
        // useRuntimeConfig() fails outside Nuxt setup context (e.g., reactive callbacks during SSR).
        // Fall back to production default without caching so a proper context can set it later.
        return 'https://imgproxy.tripening.com';
    }
    return _cachedProxyHost;
}

export function imageUrlWithProxy(url: string, width: number, height: number, resizeType: string = 'fill'): string {
    return `${getProxyHost()}/insecure/${resizeType}/${width}/${height}/sm/0/plain/${url}@webp`
}

export function imageUrlWithProxySrcset(url: string, width: number, height: number, resizeType: string = 'fill') {
    const w1 = imageUrlWithProxy(url, width, height, resizeType)
    const w2 = imageUrlWithProxy(url, width * 2, height * 2, resizeType)
    return { src: w1, srcset: `${w1} 1x, ${w2} 2x` }
}
